<p-table [value]="envelopes" [paginator]="false" class="footer-over-pagination" responsiveLayout="scroll">
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">
        {{ 'General.noFilteredData' | translate }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th class="col-icon d-none d-sm-block"></th>
      <th class="w-25">Descripción</th>
      <th class="w-25">Descifrado</th>
      <th class="w-25">Validación de firmas</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-envelope>
    <tr>
      <td class="col-icon d-none d-sm-block">
        <!-- SI TODOS LAS OFERTAS ESTAN CIFRADAS -->
        <span *ngIf="envelope['deciphered'] === 0">
          <i class="fa fa-lock fa-2x" style="color:red"></i>
        </span>

        <!-- SI EL SOBRE ESTA DESCIFRADO Y VALIDADO CORRECTAMENTE -->
        <span *ngIf="
          envelope['deciphered'] > 0 &&
          envelope['deciphered'] === envelope['total'] &&
          envelope['validated'] > 0 &&
          envelope['validated'] === envelope['total']
        ">
          <i class="fa fa-2x fa-unlock"></i>
        </span>

        <!-- SI SE ESTAN PROCESANDO LAS OFERTAS DEL SOBRE (DESCIFRANDO O VALIDANDO) -->
        <span *ngIf="
          (envelope['deciphered'] > 0 &&
            envelope['deciphered'] !== envelope['total']) ||
          (envelope['validated'] > 0 &&
            envelope['validated'] !== envelope['total'])
        ">
          <i class="fa fa-cog fa-2x fa-fw" [ngClass]="(inProgress) ? 'fa-spin' : undefined"></i><span
            class="sr-only"></span>
        </span>
      </td>
      <td class="w-25">{{ envelope.description }}</td>
      <td class="w-25">
        <p-progressBar [value]="(envelope['deciphered'] && envelope['total']) ?
        ((envelope['deciphered'] / envelope['total']) * 100).toFixed(0)
        : 0
      "></p-progressBar>
      </td>
      <td class="w-25">
        <p-progressBar class="customProgress" [value]="(envelope['validated'] && envelope['total']) ?
        ((envelope['validated'] / envelope['total']) * 100).toFixed(0)
        : 0">
        </p-progressBar>
      </td>
    </tr>
  </ng-template>
</p-table>